import { text2Expressions, triggerMemoizationsCacheClear } from '../../../misc/text2Expressions';

/**
 * Returns true is the directory item/exhibitor contains all the words (separated by spaces) in the name or description
 * @param {string} text String to find
 * @param {object} directoryItem Directory item object (or exhibitor)
 * @returns boolean
 */
export function isDirectoryItemMatchForText(text, directoryItem) {
    for (let expr of text2Expressions(text)) {
        if (!directoryItem.name.match(expr) && !directoryItem.description.match(expr)) return false;
    }
    triggerMemoizationsCacheClear();
    return true;
}
